import React, { useEffect } from "react";
import {
  SET_HISTORY_FOR_QUICK_BUY,
  CHANGE_BUY_SEARCH_TEXT,
  SET_CATEGORY
} from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import loadable from "@loadable/component";
const BuyPageMain = loadable(() =>
  import(/* webpackChunkName: "BuyPageMain" */ "../components/BuyPageMain")
);
const CategoryBuyMainPage = loadable(() =>
  import(
    /* webpackChunkName: "CategoryBuyMainPage" */ "../components/CategoryBuyMainPage"
  )
);

import "../styles/discountCard.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";
import { useLocation, useHistory, useParams } from "react-router-dom";

const DiscountBuy = ({}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(initAppBrowser(["messages", "categories", "buy"]));
    dispatch(defaultAction(SET_HISTORY_FOR_QUICK_BUY, null));
    return () => {
      dispatch(defaultAction(SET_CATEGORY, ""));
      dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
    };
  }, []);

  useEffect(() => {
    dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
  }, [params.id]);

  return location.pathname === "/buy-gift-cards" ||
    location.pathname === "/buy-gift-cards/" ? (
    <BuyPageMain />
  ) : (
    <CategoryBuyMainPage history={history} location={location} />
  );
};

export default DiscountBuy;
